import PawModel from './PawModel';

class User extends PawModel {
  static apiType = 'users';

  static d3Compatible = false;

  first_name!: string;

  last_name!: string;

  full_name!: string;

  email!: string;

  status!: string;

  letters!: string;

  read_level!: string;

  inactive_at!: string;

  current_sign_in_at!: string;

  last_sign_in_at!: string;

  status_changed_at!: string;

  skill_ids!: string[];

  picture_url!: string;

  superfields!: any;

  roles!: string[];

  auth_roles!: string[];

  login!: string;

  group_ids!: string;

  current_auth_role!: string;

  phone_number!: string;

  cellular_telephone_number!: string;

  salutation!: string;
}

export default User;
